import { useState } from "react";
import { ChevronDown } from "lucide-react";
import Text from "./Text";

const Accordion = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border-b border-gray-100">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between py-4 text-left gap-4"
      >
        <Text is="span" className="text-sm font-semibold text-gray-800">{question}</Text>
        <ChevronDown
          size={16}
          className={`flex-shrink-0 text-gray-400 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${open ? "max-h-96 pb-4" : "max-h-0"}`}
      >
        <Text is="p" className="text-sm text-gray-500 leading-relaxed">{answer}</Text>
      </div>
    </div>
  );
};

export default Accordion;
